export default __webpack_public_path__ + "static/media/peerling_team.82d92351.png";